import { render, staticRenderFns } from "./ti10.vue?vue&type=template&id=1d0a1566&scoped=true&"
import script from "./ti10.vue?vue&type=script&lang=js&"
export * from "./ti10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0a1566",
  null
  
)

export default component.exports